import { useMemo, useCallback } from 'react';

import {
  getSkillDefaultDescription,
  getSkillDefaultLabel,
  getSkillGroupDefaultLabel,
  getSkillGroupId,
  getSkillId,
  getSkillProficiency,
  isSkill,
  isSkillGroupExpanded,
  setSkillProficiency,
} from '../functions';

import { FieldSkillTreeWithProficiency } from './FieldSkillTreeWithProficiency';
import { FieldSkillTree } from './FieldSkillTree';

export const FieldSkillTreeWithOptionalProficiency = ({
  input,
  meta,
  proficiencyOptions,
  menu,
  disabled,
  showOnlySelected,
  showOnlyNonEmpty,
  onExpandGroup,
  getOptionLabel,
  isUpdatingEntity,
}) => {
  const onChange = useCallback(
    (value) => {
      input.onChange(value);
    },
    [input],
  );

  const isSkipped = useCallback((submenu) => getSkillGroupId(submenu) === getSkillGroupId(menu), [menu]);

  const selectedOptions = useMemo(() => input.value || [], [input.value]);

  return proficiencyOptions.length ? (
    <FieldSkillTreeWithProficiency
      meta={meta}
      input={input}
      menu={menu}
      disabled={disabled}
      selectedOptions={selectedOptions}
      showOnlySelected={showOnlySelected}
      showOnlyNonEmpty={showOnlyNonEmpty}
      proficiencyOptions={proficiencyOptions}
      isOption={isSkill}
      isSkipped={isSkipped}
      isExpanded={isSkillGroupExpanded}
      getOptionId={getSkillId}
      getOptionLabel={getOptionLabel || getSkillDefaultLabel}
      getMenuId={getSkillGroupId}
      getMenuLabel={getSkillGroupDefaultLabel}
      getOptionValueForGauge={getSkillProficiency}
      setOptionValueFromGauge={setSkillProficiency}
      getOptionDescription={getSkillDefaultDescription}
      onChange={onChange}
      onExpandGroup={onExpandGroup}
      isUpdatingEntity={isUpdatingEntity}
    />
  ) : (
    <FieldSkillTree
      meta={meta}
      input={input}
      menu={menu}
      disabled={disabled}
      selectedOptions={selectedOptions}
      showOnlySelected={showOnlySelected}
      showOnlyNonEmpty={showOnlyNonEmpty}
      isOption={isSkill}
      isSkipped={isSkipped}
      isExpanded={isSkillGroupExpanded}
      getOptionId={getSkillId}
      getOptionLabel={getOptionLabel || getSkillDefaultLabel}
      getMenuId={getSkillGroupId}
      getMenuLabel={getSkillGroupDefaultLabel}
      onChange={onChange}
      onExpandGroup={onExpandGroup}
    />
  );
};
